import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function SimpleProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={styles.spinner}>
        <div style={styles.spinnerIcon}>⏳</div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

const styles = {
  spinner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '400px',
    gap: '1rem'
  },
  spinnerIcon: {
    fontSize: '2rem',
    animation: 'spin 1s linear infinite'
  }
};

// Add spinner animation
const styleSheet = document.createElement('style');
styleSheet.innerHTML = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

if (!document.head.querySelector('[data-spinner-styles]')) {
  styleSheet.setAttribute('data-spinner-styles', 'true');
  document.head.appendChild(styleSheet);
}
